module.exports = __webpack_public_path__ + "media/images/icon_ul-b4adf88d43430ba6a0b861995699ebe5.svg";